// Models
import { ManagerResource } from '~/modules/manager/resource/manager-resource.model';

// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type { TManagerCompanyAlias } from '~/modules/manager/types';

export class ManagerAliasesModel extends ManagerResource {
  protected endpoint: string = 'aliases/';

  public search(
    query: string,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TManagerCompanyAlias[]> {
    return this.get<TManagerCompanyAlias[]>(`search/${query}`, undefined, requestConfig);
  }
}
